import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=ac06fe4a&"
import script from "./NewOrder.vue?vue&type=script&lang=js&"
export * from "./NewOrder.vue?vue&type=script&lang=js&"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=ac06fe4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports